import React from 'react';

export const ColumnIcon = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--column-icon';
  color = color || '#0076CC';

  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path d="M1 1H6.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 5H6.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 9H6.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 13H6.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.5 1H17" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.5 5H17" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.5 9H17" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.5 13H17" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ColumnIcon;
